import { useSelector } from "react-redux";
import { DeleteCarePrincipalModal } from "./DeleteCarePrincipalModal";
import { Delete } from "./Delete";
import { DeleteTransactionModal } from "./DeleteTransactionModal";
import { LoginTestUserModal } from "./LoginTestUserModal";
import { RegisterOptOutModal } from "./RegisterOptOutModal";
// COMFACT - KOMMER ATT TAS BORT 
// import { UpdateAllowedContractModal } from "./UpdateAllowedContractModal";
import { UpdateCarePrincipalModal } from "./UpdateCarePrincipalModal";
import { UpdateTransactionModal } from "./UpdateTransactionModal";
import { RegisterCardModal } from "./RegisterCardModal";
import { ChangeCardModal } from "./ChangeCardModal";
import { OrderCardModal } from "./OrderCardModal";
import { OptInModal } from "./OptInModal";
import { ChangeConsentModal } from "./ChangeConsentModal";
import { Reset } from "./Reset";
import { AddTransactionModal } from "./AddTransactionModal";
import { ShowGroupHistoryModal } from "./ShowGroupHistoryModal";
import { ConfirmModal } from "./ConfirmModal";
import { useTranslation } from "react-i18next";
import { OptOutModal } from "./OptOutModal";

export function ModalRoot() {
  const { t } = useTranslation();

  const renderSwitch = (modalType: string) => {
    switch (modalType) {
      case "registerOptOut":
        return <RegisterOptOutModal />;
      case "login":
        return <LoginTestUserModal />;
      case "deleteTransaction":
        return <DeleteTransactionModal />;
      case "deleteCarePrincipal":
        return <DeleteCarePrincipalModal />;
      case "updateCarePrincipal":
        return <UpdateCarePrincipalModal />;
      case "updateTransaction":
        return <UpdateTransactionModal />;
      // COMFACT - KOMMER ATT TAS BORT 
      // case "updateAllowedContract":
      //   return <UpdateAllowedContractModal />;
      case "registerCard":
        return <RegisterCardModal />;
      case "changeCard":
        return <ChangeCardModal />;
      case "delete":
        return <Delete />;
      case "orderCard":
        return <OrderCardModal />;
      case "optIn":
        return <OptInModal />;
      case "optOut":
        return <OptOutModal />;
      case "changeConsent":
        return <ChangeConsentModal />;
      case "reset":
        return <Reset />;
      case "addTransaction":
        return <AddTransactionModal />;
      case "groupHistory":
        return <ShowGroupHistoryModal />;
      case "group":
        return (
          <ConfirmModal
            title={t("group.group")}
            description={t("group.certainOfGroup")}
          />
        );
      case "unGroup":
        return (
          <ConfirmModal
            title={t("group.removeGroup")}
            description={t("group.certainOfUngroup")}
          />
        );
      default:
        return null;
    }
  };

  const modal = useSelector((state: any) => state.modal.modalType);

  return <>{renderSwitch(modal)}</>;
}
